import { createSlice } from '@reduxjs/toolkit';

export const name = 'systemTheme';

const theme = localStorage.getItem('SYSTEM_THEME') || 'light-blue_';

const systemTheme = createSlice({
    name: name,
    initialState: theme,
    reducers: {
        changeTheme: (state, actions) => {
            localStorage.setItem('SYSTEM_THEME', actions.payload);
            return actions.payload;
        }
    }
});

export const { changeTheme } = systemTheme.actions;
export default systemTheme.reducer;
